import {
    RaikoLabel
} from "@moeindal/base-raiko-panel-components"
import "./RaikoFormFileSelector.scss"
import React, {useRef, useState} from "react";
import {LinearProgress} from "@mui/material";
import {css} from "@emotion/css";

import pdfIcon from "../../assets/svg/pdf.svg"
import wordIcon from "../../assets/svg/word-svgrepo-com.svg";
import PropTypes from "prop-types";

export default function RaikoFormFileSelector(
    {
        formType = raikoFormFileTypes.PDF_FILE,
        fileName = `لطفا فایل ${formType.name} مورد نظر را انتخاب نمایید`,
        setFileName,
        file,
        setFile,
        loading,
        progress,
        buffer
    }) {

    const formFileRef = useRef(null);

    function selectFile() {
        formFileRef.current.click()
    }

    function uploadPdfFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            // setPdfFileId(-1)
            setFile(files[0])
            setFileName(files[0].name)
        }
    }


    return (
        <div className={"formFileSelectorLayout"}>
            <div className={"formFileSelectorContainer"} onClick={selectFile}>
                <input
                    ref={formFileRef}
                    type={formType.type}
                    hidden={true}
                    accept={formType.accept}
                    onChange={uploadPdfFile}
                />
                <RaikoLabel
                    text={fileName && fileName.length > 0 ? fileName : `لطفا فایل ${formType.name} مورد نظر را انتخاب نمایید`}/>
                <img src={formType.icon} alt=""/>
                {
                    loading &&
                    <div className={"progressLoadingContainer"}>
                        <div>
                        <span className={"loadingHintTitle"}>
                             ({progress + "%"}) در حال بارگزاری فایل word، لطفا صبور باشید...
                        </span>
                            <LinearProgress
                                hidden={loading} className={css`width: 100%`}
                                variant={"buffer"}
                                value={progress}
                                valueBuffer={buffer}
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export const raikoFormFileTypes = {
    PDF_FILE: {
        name: "PDF",
        type: "file",
        accept: "application/pdf",
        icon: pdfIcon
    }, WORD_FILE: {
        name: "WORD",
        type: "file",
        accept: ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        icon: wordIcon
    },
}


RaikoFormFileSelector.propTypes = {
    formType: PropTypes.any.isRequired,
    fileName: PropTypes.string.isRequired,
    setFileName: PropTypes.func.isRequired,
    file: PropTypes.any.isRequired,
    setFile: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    progress: PropTypes.number.isRequired,
    buffer: PropTypes.number
}


